import React, { useEffect, useState } from "react";
import { Typography, Box } from "@mui/material";

const convertToPersianNumbers = num => {
    const persianDigits = "۰۱۲۳۴۵۶۷۸۹";
    return num.toString().replace(/\d/g, d => persianDigits[d]);
};

const EventTimer = ({ type }) => {
    const calculateTimeLeft = () => {
        const targetDate = new Date("2025-06-25T16:04:04").getTime();
        const now = new Date().getTime();
        const difference = targetDate - now;

        let timeLeft = {};
        if (difference > 0) {
            timeLeft = {
                ثانیه: Math.floor((difference / 1000) % 60),
                دقیقه: Math.floor((difference / 1000 / 60) % 60),
                ساعت: Math.floor((difference / (1000 * 60 * 60)) % 24),
                روز: Math.floor(difference / (1000 * 60 * 60 * 24)),
            };
        }
        return timeLeft;
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    return (
        <Box sx={{ textAlign: "center" }}>
            {Object.keys(timeLeft).length > 0 ? (
                <Box display="flex" gap={type === "header" ? { xs: 1, md: 2 } : 2} justifyContent="center">
                    {Object.keys(timeLeft).map(key => (
                        <Box key={key} sx={{ textAlign: "center"}}>
                            {/* Number inside orange box */}
                            <Box
                                sx={{
                                    backgroundColor: "#F57C00",
                                    color: "white",
                                    p: type === "header" ? 0.25 : 1,
                                    borderRadius: 1,
                                    minWidth: type === "header" ? { xs: "38px", md: "50px" } : { xs: "60px", md: "80px" },
                                }}
                            >
                                <Typography fontSize={type === "header" ? { xs: "0.75rem", md: "1.25rem" } : "1.5rem"} fontWeight="bold">
                                    {convertToPersianNumbers(timeLeft[key])}
                                </Typography>
                            </Box>
                            {/* Label below the number */}
                            <Typography
                                fontSize={type === "header" ? { xs: "0.625rem", md: "0.875rem" } : "1rem"}
                                color={type === "header" ? "var(--light-color)" : "black"}
                                sx={{ mt: 0.5 }}
                            >
                                {key}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            ) : (
                <Typography variant="h6" color="black">
                    زمان رویداد به پایان رسیده است!
                </Typography>
            )}
        </Box>
    );
};

export default EventTimer;
